import { combineReducers } from 'redux';
import connectionReducer, { Connection } from './slices/connectionsSlice';
import tagReducer from './slices/tagsSlice';
import applicationReducer, { ApplicationType } from './slices/applicationSlice';
import adminReducer, { AdminState } from './slices/adminSlice';
import { TagState } from '../types/Tag';
import userReducer, { UserState } from './slices/userSlice';
import eventReducer, { EventState } from './slices/eventSlice';
import taskReducer, { TasksState } from './slices/taskSlice';
import photoAlbumReducer, { PhotoAlbumState } from './slices/photoAlbumSlice';
import formsReducer, { FormsState } from './slices/formsSlice';

export type RootState = {
  connections: Connection[];
  application: ApplicationType;
  tags: TagState[];
  admins: AdminState;
  user: UserState;
  events: EventState;
  tasks: TasksState;
  photoAlbum: PhotoAlbumState;
  forms: FormsState;
};

const combinedReducer = combineReducers<RootState>({
  connections: connectionReducer,
  tags: tagReducer,
  application: applicationReducer,
  admins: adminReducer,
  user: userReducer,
  events: eventReducer,
  tasks: taskReducer,
  photoAlbum: photoAlbumReducer,
  forms: formsReducer,
});

const rootReducer = (state: any, action: any): any => {
  if (action.type === 'application/logout') {
    localStorage.removeItem('persist:root');
    state = undefined;
  }
  if (action.type === 'application/wipeSelectedCommunity') {
    state = state || {};
    state.connections = undefined;
    state.tags = undefined;
    state.admins = undefined;
    state.events = undefined;
    state.tasks = undefined;
    state.user = undefined;
    state.forms = undefined;
  }
  if (action.type === 'application/wipeSelectedBusiness') {
    state = state || {};
    state.connections = undefined;
    state.tags = undefined;
    state.admins = undefined;
    state.events = undefined;
    state.tasks = undefined;
    state.user = undefined;
    state.forms = undefined;
  }
  const knownKeys = ['connections', 'tags', 'application', 'admins', 'user', 'events', 'tasks', 'photoAlbum', 'forms'];
  const filteredState = state
    ? knownKeys.reduce((acc, key) => {
        if (state[key] !== undefined) {
          acc[key] = state[key];
        }
        return acc;
      }, {} as any)
    : state;
  return combinedReducer(filteredState, action);
};

export default rootReducer;
